// extracted by mini-css-extract-plugin
module.exports = {"root":"_8b1356b2cc25f11cc7dbb115142cf8b1","svg":"_54ff2ebb83f34cdb22adbb4e0b388546","coin":"b84230aaaf69c75e12bb3afcc3881693"};